/*
 *
 * MicrosoftVerify actions
 *
 */

import { VERIFY_MICROSOFT } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyMicrosoft = {
  start: ({ payload, metadata }) =>
    defineAction({ type: VERIFY_MICROSOFT.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_MICROSOFT.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_MICROSOFT.ERROR,
      payload: {
        error,
      },
    }),
};
